import { ChevronDown, CrossIcon } from 'assets/icons';
import IconTooltip from 'components/iconTooltip/IconTooltip';
import { toolIcon } from './toolIcon';
import { toolProviderText } from './toolProviderTexts';

export const TOOL_PROVIDER_COMPANY = 'company';
export const TOOL_PROVIDER_TEMP_WORKER = 'temp_worker';

const otherProvider = (provider) =>
  provider === TOOL_PROVIDER_COMPANY
    ? TOOL_PROVIDER_TEMP_WORKER
    : TOOL_PROVIDER_COMPANY;

const ProviderSentence = ({ toolName, provider, readOnly, onSwitch }) => {
  const verb = toolProviderText(`verb.${provider}`);
  const who = toolProviderText(`who.${provider}`);

  if (readOnly) {
    return (
      <span className="text-sm text-gray-500">
        {verb} <span className="font-medium text-gray-900">{who}</span>
      </span>
    );
  }

  return (
    <span className="text-sm text-gray-500">
      {verb}{' '}
      <IconTooltip
        label={toolProviderText(`switchTo.${otherProvider(provider)}`)}
      >
        <button
          type="button"
          onClick={onSwitch}
          aria-label={toolProviderText('providerLabel', {
            name: toolName,
            who,
          })}
          className="inline-flex items-center gap-1 font-medium text-gray-900 underline decoration-gray-300 decoration-dashed underline-offset-4 hover:decoration-gray-900 focus:outline-none focus-visible:rounded focus-visible:ring-2 focus-visible:ring-yellow-500"
        >
          {who}
          <span aria-hidden="true">
            <ChevronDown wh={14} color="currentColor" />
          </span>
        </button>
      </IconTooltip>
    </span>
  );
};

/**
 * Equipment as sentences, the company design: "Gants fourni par l'entreprise",
 * the provider switched from the underlined word, the cross to remove the tool.
 */
const ToolProviderList = ({ tools, onChange, readOnly = false }) => {
  if (!Array.isArray(tools) || tools.length === 0) return null;

  const switchProvider = (name) =>
    onChange?.(
      tools.map((tool) =>
        tool.name === name
          ? { ...tool, providedBy: otherProvider(tool.providedBy) }
          : tool,
      ),
    );

  const removeTool = (name) =>
    onChange?.(tools.filter((tool) => tool.name !== name));

  return (
    <ul className="divide-y divide-gray-100 rounded-lg border border-gray-100 bg-white">
      {tools.map((tool) => {
        const Icon = toolIcon(tool.name);
        return (
          <li key={tool.name} className="flex items-center gap-2 px-4 py-3">
            <span aria-hidden="true" className="mr-1 shrink-0">
              <Icon wh={20} color="#1f2937" />
            </span>
            <span className="min-w-0 break-words text-sm font-medium text-gray-900">
              {tool.name}
            </span>
            <span className="flex-1">
              <ProviderSentence
                toolName={tool.name}
                provider={tool.providedBy}
                readOnly={readOnly}
                onSwitch={() => switchProvider(tool.name)}
              />
            </span>
            {readOnly ? null : (
              <IconTooltip label={toolProviderText('removeTooltip')}>
                <button
                  type="button"
                  onClick={() => removeTool(tool.name)}
                  aria-label={toolProviderText('remove', { name: tool.name })}
                  className="rounded-md p-1.5 text-gray-500 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-500"
                >
                  <span aria-hidden="true">
                    <CrossIcon wh={16} color="currentColor" />
                  </span>
                </button>
              </IconTooltip>
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default ToolProviderList;
